import React from "react";
import { Link } from "react-router-dom";

const PostFooter = () => {
    return (
        <section className="container m-0" id="footer">
            <div className="row">
                {/* Logo */}
                <div className="col-4">
                    <h1>Logo will be here</h1>
                </div>
                {/* Other links */}
                <div className="col">
                    <div className="container">
                        <div className="row"><Link to="/">Adrak</Link></div>
                        <div className="row"><Link to="/">Adrak</Link></div>
                        <div className="row"><Link to="/">Adrak</Link></div>
                        <div className="row"><Link to="/">Adrak</Link></div>
                        <div className="row"><Link to="/">Adrak</Link></div>
                        <div className="row"><Link to="/">Adrak</Link></div>
                        <div className="row"><Link to="/">Adrak</Link></div>
                    </div>
                </div>
                <div className="col">
                    <div className="container">
                        <div className="row"><Link to="/">Lahsun</Link></div>
                        <div className="row"><Link to="/">Lahsun</Link></div>
                        <div className="row"><Link to="/">Lahsun</Link></div>
                        <div className="row"><Link to="/">Lahsun</Link></div>
                        <div className="row"><Link to="/">Lahsun</Link></div>
                        <div className="row"><Link to="/">Lahsun</Link></div>
                        <div className="row"><Link to="/">Lahsun</Link></div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default PostFooter;